/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Incode_LabelInputs */



/**
* | output |
* | --- |
* | "Incode" |
*
* @param {Subtitle_Export_Incode_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_incode_label = /** @type {((inputs?: Subtitle_Export_Incode_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Incode_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code d'entrée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Incode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incodificare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встроенный код")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incodificar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Incode")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोड में")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incode")
	return /** @type {LocalizedString} */ ("Incode")
});